import { useEffect, useRef } from "react";

/**
 * Runs an effect only after the initial mount.
 * @param {Function} effect - effect function
 * @param {Array} deps - dependency array
 */
const useEffectAfterMount = (effect, deps) => {
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return; // skip effect on first render
    }
    return effect(); // run normally after first render
    // Same contract as useEffect: the caller passes the dependency list
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};

export default useEffectAfterMount;